import React from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { OneVerifyIntegrationCategory } from "@common-shared/types/integrations.types"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { ButtonElement } from "@front-shared/elements/button.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { INTEGRATIONS_CONFIG } from "../../config/integrations.config"

export const IntegrationCategoriesComponent: React.FunctionComponent<
    IIntegrationCategoriesComponentProps
> = props => {
    return (
        <div
            className={`
                inline-flex rounded-[100px] p-[4px] gap-[4px]
                bg-brand-warmLight2 border border-solid border-brand-offWhite2
                ${props.className ?? ""}
            `}
            role="tablist"
            aria-label="Integration category"
        >
            {INTEGRATIONS_CONFIG.displayCategories.map(category => {
                const isSelected = category.key === props.activeCategory

                return (
                    <ButtonElement
                        key={category.key}
                        htmlType="button"
                        type="default"
                        role="tab"
                        ariaSelected={isSelected}
                        size="middle"
                        onClick={() => {
                            props.onCategoryChange(category.key)
                        }}
                        buttonClassName={`
                            !flex !items-center !justify-center !gap-[8px]
                            !rounded-[100px] !px-[20px] !py-[10px] !min-w-[120px] !h-auto !shadow-none !border-0
                            transition-colors
                            ${
                                isSelected
                                    ? "!bg-brand-primary hover:!bg-brand-primary"
                                    : "!bg-transparent hover:!bg-brand-warmLight025"
                            }
                        `}
                    >
                        <FontAwesomeIcon
                            icon={category.icon}
                            className="text-[16px] shrink-0"
                            style={{
                                color: isSelected
                                    ? NIRVANA_COLORS.brand.white
                                    : NIRVANA_COLORS.brand.primary,
                            }}
                        />

                        <PrimaryText
                            typography="buttonText"
                            color={
                                isSelected
                                    ? NIRVANA_COLORS.brand.white
                                    : NIRVANA_COLORS.brand.primary
                            }
                        >
                            {category.label}
                        </PrimaryText>
                    </ButtonElement>
                )
            })}
        </div>
    )
}

interface IIntegrationCategoriesComponentProps {
    className?: string
    activeCategory: OneVerifyIntegrationCategory
    onCategoryChange: (category: OneVerifyIntegrationCategory) => void
}
